import { Grid } from '@mui/material';
import A from 'components/Link/Link';
import { CATEGORY } from 'config/fe-routes';
import { useTranslation } from 'react-i18next';
import { ProductType } from 'types/product.types';
import { categoryNameToUrl } from 'utils/url';

type ProductTagsProps = {
  product: ProductType;
};

const ProductTags = (props: ProductTagsProps) => {
  const { product } = props;
  const { t } = useTranslation();

  // Don't show empty tags
  if (!product?.tags?.length) {
    return null;
  }

  return (
    <>
      <Grid container className="category-container">
        <Grid xs={12}>{t('components.page-product.product-tags.category')}:</Grid>

        {/* tags / categories */}
        {product.tags.map((tag) => (
          <Grid xs={12} key={tag}>
            <A className="primary" {...CATEGORY(categoryNameToUrl(t([`common.categories.${categoryNameToUrl(tag)}`, tag])))}>
              {t([`common.categories.${categoryNameToUrl(tag)}`, tag])}
            </A>
          </Grid>
        ))}
      </Grid>
      {/* depict.ai recommendations container */}
      <div className="depict_product_page" />
    </>
  );
};

export default ProductTags;
